import { Calendar } from "react-calendar";
import { animated, useSpring } from '@react-spring/web'
import { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import dayjs from "dayjs";
import useAvailabilities from "../../services/availabilities";

const Modal = forwardRef((props, ref) => {
    const [s, ss] = useState(false)
    const [shopId, setShopId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedDate, setSelectedDate] = useState(dayjs().add(1, 'day'))
    const [disabledDates, setDisabledDates] = useState(null)

    const { data, isLoading, error } = useAvailabilities(shopId);

    useImperativeHandle(ref, () => ({
        toggleModal(shopId) {
            setShopId(shopId);
            setModalOpen(p => !p)
        }
    }))

    useEffect(() => {
        if (!data) return;
        const active = [];
        const disabled = [];
        data.availabilities.forEach(a => {
            if (
                a.m_capacity > 0.8 ||
                a.closed ||
                dayjs().isAfter(a.date)
            ) {
                return disabled.push(a);
            }
            active.push(a)
        })

        setDisabledDates(disabled);
        setSelectedDate(dayjs(active[0].date))
    }, [data])

    const leftSpring = useSpring({
        translateX: !s ? "-100%" : "0%",
        width: "50%",
        height: "100%"
    })

    const rightSpring = useSpring({
        translateX: !s ? "200%" : "100%",
        width: "50%",
        height: "100%"
    })

    const closeSpring = useSpring({
        scale: !s ? 0 : 1,
        delay: !s ? 0 : 400
    })

    const [styles, api] = useSpring(() => ({
        scale: 0,
        fontSize: 20,
        color: "red"
    }))

    const onHover = () => {
        api.start({
            scale: 1,
            fontSize: 25,
            color: "white"
        })
    }

    const onHoverOut = () => {
        api.start({
            scale: 0,
            fontSize: 20,
            color: "red"
        })
    }

    if (!modalOpen) return null;

    return (
        <div
            className="absolute top-0 w-screen h-screen bg-black bg-opacity-75 flex justify-center items-center z-50"
            onClick={(e) => {
                if (e.target != e.currentTarget) return;
                setModalOpen(p => !p)
            }}
        >
            {
                isLoading
                    ? (
                        <p
                            className="text-white italic text-2xl"
                        >
                            Henter dit tilbud...
                        </p>
                    )
                    : (
                        <div
                            className="bg-white rounded-md max-w-xl overflow-y-hidden relative flex"
                        >
                            <div
                                className="bg-skgBlue w-96 text-white px-3 py-6"
                            >
                                DATO
                            </div>
                            <Calendar
                                className="p-3"
                                value={selectedDate.toDate()}
                                locale="da-DK"
                                minDetail="month"
                                minDate={dayjs().add(1, 'day').toDate()}
                                tileDisabled={({ date }) => {
                                    const dateObj = dayjs(date);
                                    if (dateObj.day() === 6 || dateObj.day() === 0) {
                                        return true;
                                    }
                                    return disabledDates.some(item => dateObj.isSame(item.date, 'date'))
                                }}
                                onChange={(date) => {
                                    setSelectedDate(dayjs(date))
                                    ss(p => !p)
                                }}
                                onClickMonth={() => alert("dada")}
                            />
                            <animated.div
                                style={leftSpring}
                                className="absolute bg-white bottom-0 border-r border-skgRed p-3"
                            >
                                <p
                                    className="text-xl font-light text-center"
                                >
                                    Vælg indleveringstid
                                </p>
                            </animated.div>
                            <animated.div
                                style={{
                                    ...closeSpring,
                                    ...{
                                        fontSize: styles.fontSize,
                                        color: styles.color
                                    }
                                }}
                                onMouseEnter={onHover}
                                onMouseLeave={onHoverOut}
                                className="cursor-pointer absolute z-10 top-[calc(50%-theme(spacing.5))] right-[calc(50%-theme(spacing.5))] h-10 w-10 rounded-full border-skgRed border-2 flex items-center justify-center bg-white"
                                onClick={() => ss(p => !p)}
                            >
                                <IoMdClose
                                    className="z-10"
                                />
                                <animated.div
                                    className="rounded-full bg-skgRed h-10 w-10 absolute cursor-pointer"
                                    style={styles}
                                />
                            </animated.div>
                            <animated.div
                                style={rightSpring}
                                className="absolute bg-white bottom-0 border-l border-skgRed p-3"
                            >
                                <p
                                    className="text-center text-xl font-light"
                                >
                                    Vælg afhentningtid
                                </p>
                            </animated.div>
                        </div>
                    )
            }
        </div>
    )
})

export default Modal;